import React from "react";
import { NormalButton } from "component/common/NormalButton";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
//import { history } from "service/helpers";
import "./style.scss";
import { useDispatch } from "react-redux";
import * as actions from "action/reportAction";
import e from "react-date-object/calendars/gregorian";

export const LegendarySupport = ({
  legendarySupportData,
  needHeader = false,
  translation = false
}) => {
  const history = useHistory();

  const { i18n, t } = useTranslation(); 
  const dispatch = useDispatch();

  function legendaryOneNavigator(url, fraudType) {
    const redirectMappings = {
      "health": { type: "medicalFraud", searchCases: ["health", "medParagraph", "reportHealth"] },
      "travel": { type: "travelFraud", searchCases: ["travel"] },
      "motor": { type: "motorFraud", searchCases: ["motor"] }
    };

    const getLastWordAfterDot = (str) => {
      const parts = str.split(".");
      return parts[parts.length - 1];
    };

    const labelWords = getLastWordAfterDot(fraudType);

    let redirectFraudType;
    for (const [key, { type, searchCases }] of Object.entries(redirectMappings)) {
      if (searchCases.some(caseValue => labelWords.includes(caseValue))) {
        redirectFraudType = type;
        break;
      }
    }

    if (!redirectFraudType) {
      return;
    }

    dispatch(actions.setReportPage(redirectFraudType));
    history.push(url);
  }
  function legendaryTwoNavigator(url) {
    history.push(url);
  }
  function legendarylogin() {
    history.push("/login");
  }

  const trackEvent = (tabClicked) => {
    window.lmSMTObj.track(tabClicked);
  }

  return (
    <div className="row legendarySupportContainer">
      {legendarySupportData.map((item, index) => {
        return (
          <React.Fragment>
            {needHeader && (
              <div className="col-lg-12 col-12 pt-3" key={index}>
                <p className="fw-800 cantWaitTitle m-0 text-center">
                  {translation ? t(item.heading) : item.heading}
                </p>
                <p className="contactText fs-16 fw-400 text-center">
                  {translation ? t(item.para) : item.para}
                </p>
              </div>
            )}
            <div className="col-lg-6 col-md-12 col-12 pt-3">
              <div className="legendarySupportOne pt-2 pb-lg-0 pb-3">
                <div className="supportOneContainer">
                  <div className="layerOne">
                    <p className="fw-800 lengendaryTitle m-0 pb-2">
                      {translation ? t(item.fraudTitleOne) : item.fraudTitleOne}
                    </p>
                    <p className="fs-14 fw-400 legendaryPara">
                      {translation ? t(item.legendParaOne) : item.legendParaOne}
                    </p>
                    <div className="d-flex flex-row butt-link">
                      <div>
                        <NormalButton
                          label={translation ? t(item.btnLabelOne) : item.btnLabelOne}
                          className="reportFraudBtn"
                          onClick={() => {
                            trackEvent(translation ? t(item.btnLabelOne) : item.btnLabelOne+"Clicked");
                            item?.btnLinkOnePrimary ? legendaryOneNavigator(item.btnLinkOnePrimary, item.btnLabelOne) : legendarylogin()
                          }}
                        />
                      </div>
                      <div className="px-lg-3">
                        <NormalButton
                          label={t("Learn more")}
                          className="learnMoreBtn"
                          onClick={() => {
                            legendaryOneNavigator(item.btnLinkOne);
                            trackEvent(t("Learn more")+"Clicked")
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-md-12 col-12 pt-3">
              <div className="legendarySupportTwo pt-2 pb-lg-0 pb-3">
                <div className="supportTwoContainer">
                  <div className={`${item.positionLayerTwo} layerTwo`}>
                    <p className="fw-800 lengendaryTitleNew m-0 pb-2">
                      {translation ? t(item.fraudTitleTwo) : item.fraudTitleTwo}
                    </p>
                    <p className="fs-14 fw-400 legendaryParaNew">
                      {translation ? t(item.legendParaTwo) : item.legendParaTwo}
                    </p>
                    <div className="d-flex flex-row">
                      <div>
                        <NormalButton
                          label={translation ? t(item.btnLabelTwo) : item.btnLabelTwo}
                          className="reportFraudBtn"
                          onClick={() => {
                            trackEvent(translation ? t(item.btnLabelTwo) : item.btnLabelTwo+"Clicked")
                            item?.btnLinkTwoPrimary ? legendaryOneNavigator(item.btnLinkTwoPrimary, item.btnLabelTwo) : legendarylogin()
                          }}
                        />
                      </div>
                      <div className="px-lg-3">
                        <NormalButton
                          label={t("Learn more")}
                          className="learnMoreBtn"
                          onClick={() => {
                            trackEvent(t("Learn more")+"Clicked")
                            legendaryTwoNavigator(item.btnLinkTwo);
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </React.Fragment>
        );
      })}
    </div>
  );
};
